module.exports = __webpack_public_path__ + "img/bg.ba212836.jpg";